import { render, staticRenderFns } from "./ListUpcomingNoOffers.vue?vue&type=template&id=85901e80"
import script from "./ListUpcomingNoOffers.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListUpcomingNoOffers.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListUpcomingNoOffers.vue?vue&type=style&index=0&id=85901e80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports